<template>
  <div class="w-full grow space-y-24 lg:max-w-[57rem]">
    <RevSkeleton height="96px" shape="rectangle" width="100%" />
    <MessageSkeleton />
    <MessageSkeleton />
    <MessageSkeleton />
    <MessageSkeleton />
  </div>
</template>

<script setup lang="ts">
import { RevSkeleton } from '@ds/components/Skeleton'

import MessageSkeleton from './components/Message/MessageSkeleton.vue'
</script>
